/**
 * Shared time utilities for cantera stats module.
 */

export function formatTime(seconds) {
  const min = Math.floor(seconds / 60);
  const sec = Math.floor(seconds % 60);
  return `${String(min).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
}

export function formatGameDate(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
}

/**
 * Determine the sport season (Aug 1 - Jul 31) for a given date.
 * Handles ISO strings, date objects, and various date formats.
 */
export function getSportSeason(dateString) {
  if (!dateString) return null;
  let dateObj;
  if (typeof dateString === 'string') {
    // Handle YYYY-MM-DD format (avoid timezone issues)
    const parts = dateString.split('T')[0].split('-');
    if (parts.length === 3) {
      dateObj = new Date(Date.UTC(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2])));
    } else {
      dateObj = new Date(dateString);
    }
  } else {
    dateObj = new Date(dateString);
  }

  if (isNaN(dateObj.getTime())) return null;

  const year = dateObj.getUTCFullYear();
  const month = dateObj.getUTCMonth(); // 0 = Jan, 7 = Aug

  if (month >= 7) {
    return `${year}-${year + 1}`;
  } else {
    return `${year - 1}-${year}`;
  }
}

export function getCurrentSeason() {
  const now = new Date();
  return getSportSeason(now.toISOString());
}
